import React, { createContext, useState, useEffect } from 'react';
import api from '../services/api';

export const AuthContext = createContext();

// Helper function to decode JWT token and extract role
const decodeJWTPayload = (token) => {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload;
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
};

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    const token = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
    const userId = localStorage.getItem('userId') || sessionStorage.getItem('userId');
    const payload = decodeJWTPayload(token);
    
    return {
      token,
      userId,
      role: payload?.role || null,
      username: payload?.username || null
    };
  });

  useEffect(() => {
    const storedToken = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
    const storedUserId = localStorage.getItem('userId') || sessionStorage.getItem('userId');

    if (storedToken && storedUserId) {
      const payload = decodeJWTPayload(storedToken);
      setAuth({ 
        token: storedToken, 
        userId: storedUserId,
        role: payload?.role || null,
        username: payload?.username || null
      });
    }
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      const newToken = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
      const newUserId = localStorage.getItem('userId') || sessionStorage.getItem('userId');
      const payload = decodeJWTPayload(newToken);
      setAuth({ 
        token: newToken, 
        userId: newUserId,
        role: payload?.role || null,
        username: payload?.username || null
      });
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const isLoggedIn = !!auth.token;

  const logIn = (token, userId, rememberMe) => {
    const payload = decodeJWTPayload(token);
    setAuth({ 
      token, 
      userId,
      role: payload?.role || null,
      username: payload?.username || null
    });

    if (rememberMe) {
      localStorage.setItem('accessToken', token);
      localStorage.setItem('userId', userId);
    } else {
      sessionStorage.setItem('accessToken', token);
      sessionStorage.setItem('userId', userId);
    }
  };

  const logOut = async () => {
    console.log(`User with ID ${auth.userId} logged out`);
    try {
      await api.post('/user/logout');
    } catch (e) {
      // Ignore errors during logout
    }
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userId');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('userId');
    setAuth({ token: null, userId: null, role: null, username: null });
  };

  return (
    <AuthContext.Provider value={{ ...auth, isLoggedIn, logIn, logOut }}>
      {children}
    </AuthContext.Provider>
  );
};
